<template>
  <div class="wrapper">
    <div class="banner" :style="bannerStyle">{{bannerText}}</div>

    <div class="desc" v-if="!lecture.focus">
      <div class="title">[2학년]{{lecture.title}}</div>

      <svg
        class="actions"
        viewBox="0 0 24 24"
        role="img"
        aria-labelledby="드롭다운메뉴e79d75e6-86c8-48b6-81bd-89e341ccfefd 드롭다운메뉴e79d75e6-86c8-48b6-81bd-89e341ccfefdDesc"
        xmlns="http://www.w3.org/2000/svg"
        style="fill: rgb(164, 164, 164); height: 28px; width: 28px;"
      >
        <title id="드롭다운메뉴e79d75e6-86c8-48b6-81bd-89e341ccfefd">드롭다운 메뉴</title>
        <path
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          role="presentation"
        />
      </svg>
    </div>
    <div class="inner" v-if="ispick">
      <b-button variant="info">강의듣기</b-button>
    </div>
  </div>
</template>

<script>
import * as R from "ramda";
import * as _ from "lodash";
export default {
  props: ["lecture"],
  computed: {
    bannerStyle() {
      if (this.lecture.focus) {
        return `background:linear-gradient(to right, #264653 0%, #2a9d8f 100%)`;
      } else {
        let uri = this.lecture.cover;
        let i = _.random(1, 10);
        return `background:url('https://picsum.photos/400/300?random=${i}') no-repeat center;`;
      }
    },
    imgsrc() {
      return require("@/assets/asset1.jpg");
    },
    bannerText() {
      if (this.lecture.focus) {
        return "EVENT BANNER";
      } else {
        return "";
      }
    },
    ispick() {
      return this.lecture.pick;
    },
  },
  watch: {
    ispick(v1, v2) {
      console.log(v1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.wrapper {
  position: relative;
  width: 100%;
  height: $cardHeight;
  border-radius: 4px;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  border-radius: 3px;
  background-color: white;
  overflow: hidden;
  box-shadow: rgba(31, 31, 31, 0.12) 0px 1px 6px,
    rgba(31, 31, 31, 0.12) 0px 1px 4px;

  display: flex;
  flex-direction: column;
  .banner {
    // background: url("../assets/asset1.jpg") no-repeat center;
    background: url("https://picsum.photos/400/300?random=2") no-repeat center;
    flex-grow: 1;

    display: flex;
    justify-content: center;
    align-items: center;
    color: $gray50;
    font-size: 2em;

    // height: 100px;
  }
  .desc {
    flex-grow: 0;
    flex-basis: 50px;
    padding: 5px 0px 5px 10px;
    font-weight: 700;
    color: $gray600;
    display: flex;

    .title {
      flex-grow: 1;
      color: $gray600;
      font-size: 0.9em;
    }
    .actions {
      flex-grow: 0;
      flex-basis: 30px;
      width: 20px;
    }
  }
  .inner {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.wrapper:hover {
  cursor: pointer;
}
</style>